import { atom } from 'recoil';

export const authState = atom<{
  uid: string | null;
  // add any other properties you need from UserCredential
}>({
  key: 'authState',
  default: { uid: null },
});
